import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const UPDATE_RETURN_ORDER_DETAILS = gql`
  mutation UpdateReturnOrderDetails(
    $where: ReturnOrderUniqueInput!
    $data: UpdateReturnOrderDetailsInput!
  ) {
    updateReturnOrderDetails(where: $where, data: $data) {
      message
      data {
        id
      }
    }
  }
`;
